'use client';

import Image from 'next/image';
import { CLASS_TRACKING_GTM } from 'constants/index';
import { getMainUrl } from 'utils/misc';
import * as styles from './HighlightCollections.css';
import { categoriesFilters } from '../Header/components/NewHeaderContext/components/HeaderFilters/categoriesFilters';
import { getHighlightedCollections } from '../Header/components/utils/getHighlightedColletions';
import { useEffect, useState } from 'react';

function CollectionItemSkeleton() {
  return (
    <div
      className={`${styles.skeletonItemWrapper} ${styles.skeletonPulse}`}
    ></div>
  );
}

interface CollectionItemProps {
  collection: {
    label: string;
    link: string;
    icon: string;
  };
}

function CollectionItem({ collection }: CollectionItemProps) {
  return (
    <a
      href={getMainUrl() + collection.link}
      key={collection.link}
      className={`${CLASS_TRACKING_GTM.COLLECTION_CARD} ${styles.itemCollection}`}
      data-bannerid={collection.link}
      data-name={collection.label}
    >
      <Image
        src={collection.icon}
        alt={collection.label}
        width={24}
        height={24}
      />
      {collection.label}
    </a>
  );
}

type CollectionHighlighted = {
  label: string;
  link: string;
  icon: string;
  highlighted?: string;
};

function HighlightCollections() {
  const [collections, setCollections] = useState<CollectionHighlighted[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const SKELETON_COUNT = 5;

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const highlighted = await getHighlightedCollections();
        setCollections(highlighted.length ? highlighted : categoriesFilters);
      } catch (e) {
        setCollections(categoriesFilters);
      } finally {
        setIsLoading(false);
      }
    };

    loadCategories();
  }, []);

  const collectionList = isLoading
    ? Array.from({ length: SKELETON_COUNT }).map((_, index) => (
        <CollectionItemSkeleton key={`skeleton-${index}`} />
      ))
    : collections.map((collection) => (
        <CollectionItem key={collection.link} collection={collection} />
      ));

  return (
    <div className={styles.sectionWrapper}>
      <h3 className={styles.sectionTitle}>Explore as coleções</h3>
      <div className={styles.collectionsContainer}>{collectionList}</div>
    </div>
  );
}

export default HighlightCollections;
